module.exports = __webpack_public_path__ + "img/volodymyr-storozhuk.38f54881.jpg";